import PropTypes from 'prop-types';

const Observation = (props) => {
    const { value, unit, showUnit } = props;

    const formatNumber = (number) => {
        const roundedNum = number.toFixed(1);
        return parseFloat(roundedNum);
    };

    if (showUnit) {
        return `${formatNumber(value)}${unit}`;
    }
    return `${formatNumber(value)}`;                    
};

Observation.propTypes = {
    value: PropTypes.number,
    unit: PropTypes.string,
    showUnit: PropTypes.bool,
};

Observation.defaultProps = {
    value: 0,
    unit: '',
    showUnit: true,
};

export default Observation;
